module.exports = __webpack_public_path__ + "img/furs.9d09c020.png";